var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("licences", {
        staticClass: "mb-6",
        attrs: { licenses: _vm.totalProductsLicences, enableSupport: false }
      }),
      _vm._v(" "),
      _c("staffs", {
        staticClass: "mt-4",
        attrs: { isReadOnly: true },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("h2", { staticClass: "mt-4" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Attribution des licences")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "lh-20 mt-0 mb-4 fs-3" }, [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.totalLabel) }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "gray-60" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$l10n.__(
                          "Les licences ont été attribuées en fonction des besoins de vos collaborateurs afin qu’ils puissent utiliser les différents modules proposés dans Sellsy."
                        )
                      )
                    )
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }